/* @flow */

export function getSuggestedCity(settings) {
  const suggestedCity = settings.cities.meta.suggested_city || null;
  if (suggestedCity === null) {
    return null;
  }

  return (
    settings.cities.objects.filter(city => city.slug === suggestedCity)[0] ||
    null
  );
}

function getSettings() {
  const $window = window || {};
  if (!$window.loggi) {
    return null;
  }
  return $window.loggi.bootstrapData;
}

export default getSettings();
